import React from 'react'
import WastePointListItem from './WastePointListItem'
import { styled } from '@mui/material'
import { Stack } from '@mui/system'
import { PoiExtendedDto, PoiType } from '../api/app.generated'

export interface WastePointListPanelProps {
    wastePoints: PoiExtendedDto[];
    selectedWastePointId?: number;
    onWastePointClick: (itemId: number, type: PoiType) => void;
}

const StyledContainer = styled(Stack)(({theme}) => ({ 
  background: `${theme.palette.background.paper}`,
  overflowY: "auto",
  flexWrap: "nowrap",
  padding: "2px"
}))

const WastePointListPanel: React.FC<WastePointListPanelProps> = ({ wastePoints, onWastePointClick, selectedWastePointId }) => {
  return (
    <StyledContainer direction="column" spacing={2}>
        {wastePoints.map((item) => (
        <div key={`${item.id}${item.type}`} onClick={() => onWastePointClick(item.id, item.type)}>
          <WastePointListItem wastePointItem={item} isSelected={selectedWastePointId === item.id} />
        </div>))}
    </StyledContainer>
  )
}

export default WastePointListPanel